/* 🤖 this file was generated by svg-to-ts */
export const matIconInsertDriveFile: {
  name: 'insert-drive-file';
  data: string;
} = {
  name: 'insert-drive-file',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"/></svg>`
};
